<div class="radio" (click)="select()">
  <div class="radio-circle" [class.selected]="isSelected" [class.disabled]="isDisabled">
    <div class="radio-dot" *ngIf="isSelected"></div>
  </div>
  <ng-content></ng-content>
</div>
